import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import AppRoutes from "./AppRoutes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initializeApiClient } from "./api/apiClient";

import "./assets/scss/theme.scss";

// MSAL configuration
const configuration = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID!,
        authority: process.env.REACT_APP_B2C_AUTHORITY_URL!,
        navigateToLoginRequestUrl: false,
        knownAuthorities: [process.env.REACT_APP_B2C_KNOWN_AUTHORITIES!],
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

const pca = new PublicClientApplication(configuration);
initializeApiClient(pca);

// React Query configuration
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

const App = () => (
    <MsalProvider instance={pca}>
        <QueryClientProvider client={queryClient}>
            <AppRoutes/>
        </QueryClientProvider>
    </MsalProvider>
);

export default App;